module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-second-white.358e8fb2.png";